import React from "react";
import AboutComponent1 from "../../components/AboutComponents/AboutComponent1/AboutComponent1";
import AboutComponent2 from "../../components/AboutComponents/AboutComponent2/AboutComponent2";
import { ImageUrl } from "../../config/helper";
import Slider from "react-slick";
import { Col, Row } from "antd";
import { useNavigate } from "react-router-dom";

const Services = () => {
  const navigate = useNavigate();
  var settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: false,
          arrows: false,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };
  return (
    <div>
      <AboutComponent1
        image={ImageUrl("servicebanner.jpg")}
        heading="Services"
      />
      <Row justify={"center"}>
        <Col xl={18} lg={20}>
          <Row justify="center" className="items-center">
            <Col xxl={18} md={20} sm={20} xs={23}>
              <h3 className="font-goldman text-white text-[40px] leading-[75px] text-center">
                Discover Our Distance Package
              </h3>
              <p className="text-[#666666] text-[15px] antialiased text-center">
                The Distance Package is perfectly flexible, pay-as-you-go
                transportation based on miles traveled and time taken up for
                your trip. Travel through the city’s busy streets in comfort,
                with rates based on miles traveled and time spent on the road.
                This package aims to meet the demands for longer trips to
                destinations such as the Tri-State area and beyond Manhattan by
                covering distance over time.
              </p>
            </Col>
          </Row>
          <Row
            justify="center"
            className="items-center py-6 servcie-slider-new"
          >
            <Col lg={24}>
              <Slider {...settings}>
                <div className="service-slider-item-box">
                  <img src={ImageUrl("ser1.png")} alt="vector" className="" onClick={() => navigate("/contact")}/>
                  <h3>Private Parties</h3>
                </div>
                <div className="service-slider-item-box">
                  <img src={ImageUrl("ser2.png")} alt="vector" className="" onClick={() => navigate("/contact")}/>
                  <h3>Airport Transfers</h3>
                </div>
                <div className="service-slider-item-box">
                  <img src={ImageUrl("ser3.png")} alt="vector" className="" onClick={() => navigate("/contact")}/>
                  <h3>Business Meetings</h3>
                </div>
                <div className="service-slider-item-box">
                  <img src={ImageUrl("ser4.png")} alt="vector" className="" onClick={() => navigate("/contact")}/>
                  <h3>City-to-City Commutes</h3>
                </div>
                <div className="service-slider-item-box">
                  <img src={ImageUrl("ser5.png")} alt="vector" className="" onClick={() => navigate("/contact")}/>
                  <h3>Shopping</h3>
                </div>
                <div className="service-slider-item-box">
                  <img src={ImageUrl("ser6.png")} alt="vector" className="" onClick={() => navigate("/contact")}/>
                  <h3>Picnics</h3>
                </div>
              </Slider>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row justify={"center"}>
        <Col lg={20}>
          <Row justify="center" className="items-center">
            <Col xxl={18} md={20} sm={20} xs={23}>
              <h3 className="font-goldman text-white text-[40px] leading-[75px] text-center">
                Half Day Package
              </h3>
              <h4 className="service-hour text-customGold">(4Hr minimum)</h4>
              <p className="text-[#666666] text-[15px] antialiased text-center">
                Our half-day package can cover up to four hours of premium
                transportation for those in need of dependable and luxurious
                transport during a part of the day. Travel hassle-free through
                the heart of New York City with your chauffeur waiting for you
                to take you to multiple destinations as needed. And the package
                can be used outside of the city, as well, where you can spend a
                smooth time exploring neighboring territories with the same
                impeccable service.
              </p>
            </Col>
          </Row>
          <Row
            justify="center"
            className="items-center py-6 servcie-slider-new"
          >
            <Col lg={20}>
              <Slider {...settings}>
                <div className="service-slider-item-box">
                  <img src={ImageUrl("ser7.png")} alt="vector" className="" onClick={() => navigate("/contact")} />
                  <h3>Concerts</h3>
                </div>
                <div className="service-slider-item-box">
                  <img src={ImageUrl("ser8.png")} alt="vector" className="" onClick={() => navigate("/contact")} />
                  <h3>Shopping Mall</h3>
                </div>
                <div className="service-slider-item-box">
                  <img src={ImageUrl("ser9.png")} alt="vector" className="" onClick={() => navigate("/contact")} />
                  <h3>Theater</h3>
                </div>
                <div className="service-slider-item-box">
                  <img src={ImageUrl("ser10.png")} alt="vector" className="" onClick={() => navigate("/contact")} />
                  <h3>Business Meetings</h3>
                </div>
                <div className="service-slider-item-box">
                  <img src={ImageUrl("ser11.png")} alt="vector" className="" onClick={() => navigate("/contact")} />
                  <h3>Games</h3>
                </div>
                <div className="service-slider-item-box">
                  <img src={ImageUrl("ser12.png")} alt="vector" className="" onClick={() => navigate("/contact")} />
                  <h3>Lunch or Dinner</h3>
                </div>
              </Slider>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row justify={"center"}>
        <Col lg={20}>
          <Row justify="center" className="items-center">
            <Col xxl={18} md={20} sm={20} xs={23}>
              <h3 className="font-goldman text-white text-[40px] leading-[75px] text-center">
                Full Day Package
              </h3>
              <h4 className="service-hour text-customGold">(8 hours )</h4>
              <p className="text-[#666666] text-[15px] antialiased text-center">
                For those looking to make the most out of their day with
                uninterrupted access to a luxury vehicle and professional
                chauffeur, the Full Day Package is the ultimate solution. With a
                minimum of eight hours, explore areas beyond Manhattan or travel
                across the Tri-State region with ease and comfort. Stay on
                schedule and enjoy luxury transport as you go about your full
                day of meetings, appointments, or sightseeing. Your personal
                chauffeur will be dedicated to your needs throughout the day.
              </p>
            </Col>
          </Row>
          <Row
            justify="center"
            className="items-center py-6 servcie-slider-new"
          >
            <Col lg={20}>
              <Slider {...settings}>
                <div className="service-slider-item-box">
                  <img src={ImageUrl("ser13.png")} alt="vector" className="" onClick={() => navigate("/contact")} />
                  <h3>NYC Tours</h3>
                </div>
                <div className="service-slider-item-box">
                  <img src={ImageUrl("ser14.png")} alt="vector" className="" onClick={() => navigate("/contact")} />
                  <h3>United Nations</h3>
                </div>
                <div className="service-slider-item-box">
                  <img src={ImageUrl("ser15.png")} alt="vector" className="" onClick={() => navigate("/contact")} />
                  <h3>shopping</h3>
                </div>
                <div className="service-slider-item-box">
                  <img src={ImageUrl("ser16.png")} alt="vector" className="" onClick={() => navigate("/contact")} />
                  <h3>Business Meetings</h3>
                </div>
                <div className="service-slider-item-box">
                  <img src={ImageUrl("ser13.png")} alt="vector" className="" onClick={() => navigate("/contact")} />
                  <h3>NYC Tours</h3>
                </div>
                <div className="service-slider-item-box">
                  <img src={ImageUrl("ser15.png")} alt="vector" className="" onClick={() => navigate("/contact")} />
                  <h3>shopping</h3>
                </div>
              </Slider>
            </Col>
          </Row>
        </Col>
      </Row>

      <section className="py-5 home-modals-box">
        <Row justify={"center"}>
          <Col lg={20}>
            <Row justify="center" className="items-center py-6">
              <Col lg={20}>
                <Row gutter={[16, 16]} justify={"center"}>
                  <Col xxl={24} md={24} sm={20} xs={23}>
                    <div
                      className="provide-best-boxs"
                      style={{ textAlign: "start" }}
                    >
                      <Row>
                        <Col lg={12}>
                          <h3 className="font-goldman text-white text-[40px] leading-[75px] service-text-40">
                            Sprinters for private Events
                          </h3>
                          <h4
                            className="service-hour text-customGold"
                            style={{ textAlign: "start" }}
                          >
                            (8 hours )
                          </h4>
                          <p className="text-[#666666] text-[15px] antialiased">
                            Our fleet of luxurious sprinter vans offers the
                            perfect solution for transporting groups to and from
                            private events. Our sprinters provide comfortable,
                            spacious, and stylish transportation for a corporate
                            outing, a wedding reception, or a night out with
                            friends. Contact us to reserve your sprinter for
                            your next private event, ensuring an enjoyable
                            transportation experience.
                          </p>
                          <button
                            className="web-btn py-3 xl:px-12 px-3 text-sm max-xl:text-xs my-4 max-lg:hidden"
                            onClick={() => navigate("/contact")}
                          >
                            Book Now
                          </button>
                        </Col>
                        <Col lg={12}>
                          <div className="anim2">
                            <img
                              src={ImageUrl("newvan.png")}
                              alt="vector"
                              className=""
                            />
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>

            {/* <Row justify="center" className="items-center py-6">
              <Col lg={14}>
                <div className="anim">
                  <img
                    src={ImageUrl("provideBest.png")}
                    alt="vector"
                    className=""
                  />
                </div>
              </Col>
            </Row> */}
          </Col>
        </Row>
      </section>

      {/* <AboutComponent2 /> */}
    </div>
  );
};

export default Services;
